module.exports = __webpack_public_path__ + "static/6-4bda6fdca972b43f2601caead06b7358.jpg";